<template>
    <section class="healthcareClinicClass">
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiHospitalMarker }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Find hospitals, clinics and doctors near you
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card>
                <v-card-text>
                    <PartnerTypeOptions @handleSelection="handleSelection" />
                    <div v-show="select === 'Hospital'">
                        <compHospitalComboBox
                            :select="select"
                            :loading="loading"
                            :search="search"
                        />
                        <NoticeMessage>
                            <template #noticeMessage>
                                <b>Important Notice:</b> The accreditation status of each facility may change before updates are reflected in this list.
                            </template>
                        </NoticeMessage>
                        <HospitalTable :loading="loading" :search="search" />
                    </div>
                    <div v-show="select === 'Clinic'">
                        <compClinicComboBox
                            :select="select"
                            :loading="loading"
                            :search="search"
                        />
                        <NoticeMessage>
                            <template #noticeMessage>
                                <b>Important Notice:</b> The accreditation status of each facility may change before updates are reflected in this list.
                            </template>
                        </NoticeMessage>
                        <ClinicTable :loading="loading" :search="search" />
                    </div>
                    <div v-show="select === 'Doctor'">
                        <compDoctorsComboBox
                            :select="select"
                            :loading="loading"
                            :search="search"
                        />
                        <NoticeMessage>
                            <template #noticeMessage>
                                <b>Important Notice:</b> The schedule and accreditation status of each doctor may change before updates are reflected in this list.
                            </template>
                        </NoticeMessage>
                        <DoctorsTable :loading="loading" :search="search" />
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </section>
</template>

<script>
import NoticeMessage from './NoticeMessage.vue'
import PartnerTypeOptions from './PartnerTypeOptions.vue'
import compHospitalComboBox from './compChoices/compHospitalComboBox.vue'
import HospitalTable from './compChoices/tables/main_tables/HospitalTable.vue'
import compDoctorsComboBox from './compChoices/compDoctorsComboBox.vue'
import DoctorsTable from './compChoices/tables/main_tables/DoctorsTable.vue'
import compClinicComboBox from './compChoices/compClinicComboBox.vue'
import ClinicTable from './compChoices/tables/main_tables/ClinicTable.vue'
import { mdiHospitalMarker } from '@mdi/js'
export default {
    components: {
        HospitalTable,
        compHospitalComboBox,
        ClinicTable,
        compClinicComboBox,
        DoctorsTable,
        compDoctorsComboBox,
        PartnerTypeOptions,
        NoticeMessage
    },
    data() {
        return {
            mdiHospitalMarker,
            loading: {
                hospital: false,
                tempHospital: false,
                clinic: false,
                tempClinic: false,
                doctor: false,
                tempDoctor: false
            },
            select: 'Hospital',
            search: {
                value: null
            }
        }
    },
    methods: {
        handleSelection(type) {
            this.select = type
        }
    }
}
</script>

<style scoped>
.search {
  height: 100%;
}
.searchBar {
  width: 50%;
  margin: auto;
}
.combobox-wrapper {
  width: 50%;
}
.combobox {
  width: 60%;
}
.contents {
  width: 100%;
}
h1 {
  text-align: center;
  color: #4caf50;
  font-size: 55px;
}

@media (max-width: 390px) {
  /* Navbar */
  .page-icon {
    display: none;
  }
}
@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

.dependent-wrapper {
  width: 95%;
}

@media (max-width: 599px) {
  .dependent-wrapper {
    width: 100%;
  }
}
</style>
